module.exports = __webpack_public_path__ + "img/Groupe 71.57df084d.svg";